import { logger, } from "@bracket/ui";
import { type ConfiguredQueries, query, } from "./client/query";
import type { EthereumAddress, VaultSymbol, } from "@bracket/types";



export declare type GetMarketPositionProps = {
	userAddress: EthereumAddress;
	marketUniqueKey: string;
	symbol: VaultSymbol;
}


export const getMarketPosition = async ({
	userAddress,
	marketUniqueKey,
	symbol,
}: GetMarketPositionProps): Promise<typeof ConfiguredQueries["MarketPosition"]["resultShape"]|null> => {

	// logger.silly(`morpho:: getMarketPosition --> getting market position for ${symbol}`);
	return query("MarketPosition", { userAddress, marketId: marketUniqueKey, chainId: 1, });
}
